// Every warm-up step (`**/*.warmup.ts`, step.ts), in order. An id declared twice is an error.
import type { WarmupStep } from './step';

const FILES = import.meta.glob<{ warmup: WarmupStep }>('../../**/*.warmup.ts', { eager: true });

export function collectSteps(all: readonly WarmupStep[]): WarmupStep[] {
  const seen = new Set<string>();
  for (const s of all) {
    if (seen.has(s.id)) throw new Error(`warm-up step ${s.id} is declared twice`);
    seen.add(s.id);
  }
  return [...all].sort((a, b) => a.order - b.order);
}

export const WARMUP_STEPS: readonly WarmupStep[] = collectSteps(Object.values(FILES).map((m) => m.warmup));
